module.exports = __webpack_public_path__ + "img/资源 2-100.dbfb3cc2.jpg";